import { fetch, windowFetch } from '@sparky/polyfills/fetch'
import type { RequestInfo, RequestInit } from '@sparky/polyfills/fetch'

export * from '@sparky/polyfills/fetch'

export const JSON_CONTENT_TYPE_HEADER: Record<string, string> = {
  'Content-Type': 'application/json',
}

export type RequestInitWithTimeout = RequestInit & { timeout?: number }

export const fetchWithTimeout = (resource: RequestInfo, options?: RequestInitWithTimeout): Promise<Response> => {
  if (!options?.timeout) {
    return windowFetch(resource, options)
  }

  const { timeout, ...opts } = options
  const controller = new AbortController()
  opts.signal = controller.signal
  const tid = setTimeout(() => controller.abort(), timeout)
  return fetch(resource, opts).then((res: Response) => {
    clearTimeout(tid)
    return res
  }, (err: Error) => {
    clearTimeout(tid)
    throw err
  })
}

export type URLParams = string | string[][] | Record<string, string> | URLSearchParams
export type UrlObjectOption = {
  baseURL?: string
  url?: string
  baseUrl: string
  path: string
  params?: URLParams
} | {
  baseURL: string
  url: string
  baseUrl?: string
  path?: string
  params?: URLParams
}
export const getUrlObject = ({
  baseURL,
  baseUrl = baseURL,
  url = baseURL,
  path = url,
  params,
}: UrlObjectOption): URL | undefined => {
  if (!path || !(baseUrl || path)?.startsWith('http')) {
    return undefined
  }
  const getUrl = () => {
    if (path && baseUrl && path !== baseUrl && !path.startsWith('http')) {
      if (baseUrl.slice(8, -1).includes('/')) {
        return new URL(
          path.startsWith('/') ? path.slice(1) : path,
          baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
        )
      }
      return new URL(path, baseUrl)
    }
    return new URL(path)
  }
  const urlObj: URL = getUrl()
  if (urlObj && params &&
    (Array.isArray(params) || typeof params === 'string' ?
      params.length : Object.keys(params).length)) {
    urlObj.search = new URLSearchParams(params).toString()
  }
  return urlObj
}

export default fetchWithTimeout
